import React, { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

function ErrorAlert({ description, onClose, title = 'Error' }) {
  return (
    <Alert severity="error" variant="filled" {...(onClose ? { onClose } : {})}>
      <AlertTitle>{title}</AlertTitle>
      {description}
    </Alert>
  );
}

function WarningAlert({ description, onClose, title = 'Warning' }) {
  return (
    <Alert
      severity="warning"
      variant="filled"
      {...(onClose ? { onClose } : {})}
    >
      <AlertTitle>{title}</AlertTitle>
      {description}
    </Alert>
  );
}

function SuccessAlert({ description, onClose, title = 'Success' }) {
  return (
    <Alert
      severity="success"
      variant="filled"
      {...(onClose ? { onClose } : {})}
    >
      <AlertTitle>{title}</AlertTitle>
      {description}
    </Alert>
  );
}

function InfoAlert({ description, onClose, title = 'Info' }) {
  return (
    <Alert severity="info" {...(onClose ? { onClose } : {})}>
      <AlertTitle>{title}</AlertTitle>
      {description}
    </Alert>
  );
}

export default function AlertItem({
  severity,
  description,
  onClose = undefined,
  keepOpen = false,
  title = null,
}) {
  useEffect(() => {
    if (severity === 'error') return;
    if (keepOpen) return;
    if (typeof onClose !== 'function') return;

    const timer = setTimeout(() => {
      onClose();
    }, 2000);
    return () => clearTimeout(timer);
  }, [onClose, severity, keepOpen]);

  // keepOpen only skips auto-dismiss; still show close when onClose is provided.
  const closeHandler = onClose;

  const isError = severity === 'error';
  const isWarning = severity === 'warning';
  const isSuccess = severity === 'success';
  const isInfo = severity === 'info';
  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {isError && (
        <ErrorAlert
          description={description}
          onClose={closeHandler}
          title={title || 'Error'}
        />
      )}
      {isWarning && (
        <WarningAlert
          description={description}
          onClose={closeHandler}
          title={title || 'Warning'}
        />
      )}
      {isSuccess && (
        <SuccessAlert
          description={description}
          onClose={closeHandler}
          title={title || 'Success'}
        />
      )}
      {isInfo && (
        <InfoAlert
          description={description}
          onClose={closeHandler}
          title={title || 'Info'}
        />
      )}
    </Stack>
  );
}
